export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-axis/src/array.js
// module id = 219
// module chunks = 0